import { render, staticRenderFns } from "./BusinessUnitModal.vue?vue&type=template&id=56e3229b&scoped=true&"
import script from "./BusinessUnitModal.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3229b",
  null
  
)

export default component.exports